export default __webpack_public_path__ + "static/media/Racializedpeople_en.551a555a.svg";